import { Badge, Popover, Space } from 'antd'
import AdditionalJobs from '../../components/calculation-form/components/form-items/additional-jobs'
import { onCellUnlessColorProofDurstRollout } from '../../helpers/color-proof-branch'
import { renderCalcPos } from '../../helpers/helpers'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'

export const additionalJobsColumn: CalculationColumn = {
    dataIndex: ['additional_jobs'],
    relationPath: ['additional_jobs'],
    title: 'Доп. работы',
    width: 88,
    editable: true,
    FormItem: <AdditionalJobs />,
    onCell: record => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        }
        return {
            ...onCellUnlessColorProofDurstRollout(record),
            style: { maxWidth: 88 },
        }
    },
    render: renderCalcPos(r => {
        const list = r.additional_jobs
        return (
            <Popover
                content={
                    <Space direction={'vertical'}>
                        {list?.map(v => <span key={v.name}>{v.name}</span>)}
                    </Space>
                }
                placement={'leftBottom'}
            >
                {(list?.length || 0) > 1 ? <Badge count={list?.length} /> : null}{' '}
                {list?.map(v => v.name).join(', ')}
            </Popover>
        )
    }),
}
